import { DOKLAD_OSTATNI as NAME, ATTACHMENT_FILES, NONGENUINE_ATTACHMENT_FILES } from '../../constants';

export { DMS_MODULE, DOKLAD_OSTATNI as NAME, ATTACHMENT_FILES, NONGENUINE_ATTACHMENT_FILES } from '../../constants';
export const DEPENDENT_TABLES = <const>[NAME, ATTACHMENT_FILES, NONGENUINE_ATTACHMENT_FILES];
